import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../authentication/authContext";

// material import
import {
  Box,
  Button,
  Card,
  Checkbox,
  FormControlLabel,
  Grid2,
  TextField,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";

// project import
import Header2 from "../../ui-components/headerii";
import HeroImage from "../../assets/suwaarana-cover-scaled.webp";
import Footer from "../../ui-components/footer";
import { useSnackbar } from "../../ui-components/snackbarProvider";

// service import
import AdminDBServices from "../../services/v1/adminDBServices";

function Index() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleLogin = async () => {
    setLoading(true);

    try {
      const response = await AdminDBServices.login(username, password);

      // Login successful
      showSnackbar(response.message, {
        severity: "success",
      });

      const token = response.data?.serviceToken || response.serviceToken;

      if (!token) {
        throw new Error("Login succeeded but no token was returned");
      }

      login(token);

      navigate("/admin-dashboard", {
        state: { name: response.data.name },
      });
    } catch (error) {
      showSnackbar(error?.message, {
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        backgroundImage: `url(${HeroImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        height: 825,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Header2 />
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleLogin();
        }}
      >
        <Grid2 container justifyContent="center" rowGap={2}>
          <Grid2
            item
            size={{ xs: 11, md: 3.5 }}
            // mr={20}
            mt={5}
            sx={{ mr: { xs: 0, md: 0 } }}
          >
            <Card sx={{ borderRadius: 2, opacity: "85%" }}>
              <Grid2 container p={2}>
                <Grid2 item size={{ xs: 12 }}>
                  <TextField
                    required
                    label="Username"
                    variant="outlined"
                    fullWidth
                    sx={{ mb: 2 }}
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                  />
                </Grid2>
                <Grid2 item size={{ xs: 12 }}>
                  <TextField
                    required
                    label="Password"
                    type={showPassword ? "text" : "password"}
                    variant="outlined"
                    fullWidth
                    sx={{ mb: 2 }}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => setShowPassword(!showPassword)}
                            edge="end"
                          >
                            {showPassword ? (
                              <VisibilityOffIcon />
                            ) : (
                              <VisibilityIcon />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid2>

                {/* <Grid2 item size={{ xs: 12 }}>
                <FormControlLabel control={<Checkbox />} label="Remember Me" />
              </Grid2> */}

                <Grid2 item size={{ xs: 12 }}>
                  <Button
                    variant="contained"
                    fullWidth
                    sx={{ bgcolor: "#8B2757" }}
                    // onClick={handleLogin}
                    type="submit"
                    disabled={loading}
                  >
                    {loading ? "Logging in..." : "Login"}
                  </Button>
                </Grid2>
              </Grid2>
            </Card>
          </Grid2>
        </Grid2>
      </form>
      <Box sx={{ mt: 33 }}>
        <Footer />
      </Box>
    </Box>
  );
}

export default Index;
